(function () {
  let lastDispatched = '';
  let lastDispatchedAt = 0;

  function dispatchRaSearchVariantUpdate(searchData) {
    const now = performance.now();

    if (searchData === lastDispatched && now - lastDispatchedAt < 80) {
      return;
    }

    lastDispatched = searchData;
    lastDispatchedAt = now;

    const pathName = new URL(location.href).pathname;

    document.dispatchEvent(
      new CustomEvent("ra:search:submit", {
        bubbles: true,
        detail: {
          query: searchData,
          page: pathName
        },
      })
    );
  }

  document.addEventListener(
    'click',
    (event) => {
      // ignore input clicks
      if (event.target.closest('.search-action--ra-input')) {
        return;
      }

      // button or fallback container
      let trigger = event.target.closest('button.svg-wrapper');
      if (!trigger) {
        trigger = event.target.closest('.search-action--ra-bar');
      }

      if (!trigger) return;

      const wrapper = trigger.closest('.search-action--ra-shell');
      if (!wrapper) return;

      const input = wrapper.querySelector('.search-action--ra-input');
      if (!input) return;

      const value = input.value.trim();
      if (!value) return;

      dispatchRaSearchVariantUpdate(value);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter') return;

      const input = event.target.closest('.search-action--ra-input');
      if (!input) return;

      event.preventDefault();

      const value = input.value.trim();
      if (!value) return;

      dispatchRaSearchVariantUpdate(value);
    },
    true
  );
})();
